// extracted by mini-css-extract-plugin
export default {"title_box":"AuditionComponent_title_box__DaIWs","img_box":"AuditionComponent_img_box__GXO2M"};